// Hands the server-side conversion's event name + id to GTM so the browser-side
// Meta tag can send the SAME pair.
//
// Meta only deduplicates when event_name AND event_id both match. Without this
// the browser copy and the Conversions API copy of one conversion are counted as
// two separate conversions.
//
// This is inert until the Meta tag in GTM is pointed at these dataLayer values —
// pushing them costs nothing if nothing reads them.
export const pushConversion = conversion => {
    if (!conversion?.eventName || !conversion?.eventId) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'server_conversion',
        conversionEventName: conversion.eventName,
        conversionEventId: conversion.eventId
    });
};
